import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message, Icon} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components/index';
import {detail, getCustomOrderList} from '../../service/customOrder/index';
import moment from 'moment';

class CustomeOrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['定制订单'],
            showHideBtnIndex: '',
            key: 0,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            total1: 1,
            rows1: [],
            searchObj: {
                code: '', // 编号
                orderStatus: '', // 状态
                customerCode: '', // 客户编号
                customerName: '', // 客户名称
                startCreatedDate: '', // 起
                endCreatedDate: '', // 止
                shipTime: {},
                s: 10,
                p: 1,
                createdBy: ''
            },
            searchObj1: {
                s: 10,
                p: 1
            },
            visible: false,
            loading: true,
            loading1: true,
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                code: '', // 编号
                orderStatus: '', // 状态
                customerCode: '', // 客户编号
                customerName: '', // 客户名称
                startCreatedDate: '', // 起
                endCreatedDate: '', // 止
                p: 0,
                s: 10,
            }
        }, () => {
            self.initData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        var sObj = this.state.searchObj;
        this.setState({
            searchObj: {
                ...this.state.searchObj, p: 1,
                startCreatedDate: sObj.shipTime.from, endCreatedDate: sObj.shipTime.end
            }
        }, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    pageChange1(page, pageSize) {
        let self = this;
        this.setState({searchObj1: {...this.state.searchObj1, s: pageSize, p: page}}, function () {
            self.initData1();
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        var x = window.localStorage.getItem('login_user_information');
        // debugger
        // console.log(x[0].id)
        this.setState({loading: true});
        obj.createdBy = x[0].id;
        getCustomOrderList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    initData1(id) {
        var self = this;
        self.setState({loading1: true});
        detail({"id": id}).then(result => {
            if (result.status && result.status == true) {
                self.setState({
                    rows1: result.data.productList,
                    loading1: false,
                    visible: true
                })
            } else {
                message.error(result.message);
            }
        });
    }

    getDetail = (id) => {
        this.initData1(id);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        // console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {
    }

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            visible,
            loading,
            rows1,
            total1,
            searchObj1,
            loading1
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'code',
                    label: '编号',
                    text: '输入编号',
                    type: 'default',
                    defaultValue: searchObj.code
                },
                {
                    name: 'orderStatus',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '待审核', text: '待审核'},
                        {value: '待发货', text: '待发货'},
                        {value: '待收货', text: '待收货'},
                        {value: '已完成', text: '已完成'},
                        {value: '已取消', text: '已取消'},
                        {value: '暂存', text: '暂存'},
                        {value: '已审核', text: '已审核'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.orderStatus || ''
                },
                {
                    name: 'customerCode',
                    label: '客户编号',
                    text: '输入客户编号',
                    type: 'default',
                    defaultValue: searchObj.customerCode
                },
                {
                    name: 'customerName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.customerName
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '订单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate || '',
                        end: searchObj.endCreatedDate || ''
                    }
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '编号',
                    dataIndex: 'code',
                    render: (text, record, index) => {
                        return <a href={`#/customOrder/${record.id}`}>{text}</a>
                    }
                }, {
                    title: '客户名称',
                    dataIndex: 'customerName'
                },
                {
                    title: '客户编号',
                    dataIndex: 'customerCode'
                },
                {
                    title: '状态',
                    dataIndex: 'orderStatus'
                },
                {
                    title: '订单日期',
                    dataIndex: 'createdDate',
                    render: (text, record, index) => {
                        return moment(parseInt(text)).format('YYYY-MM-DD HH:mm:ss')
                    }
                },
                {
                    title: '联系电话',
                    dataIndex: 'phone'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '简要信息',
                    dataIndex: 'status',
                    render: (text, record, index) => (
                        <div>
                            <Button type="primary"
                                    onClick={this.getDetail.bind(this, record.id)}>
                                查看
                            </Button>
                        </div>)
                }
            ],
            rows
        };

        const tableDetailViewProps = {
            loading: loading1,
            rowKey: 'id',
            pageParam: {
                total: total1,
                current: searchObj1.p,//当前页码
                pageSize: searchObj1.s,//当前分页数
                onChange: this.pageChange1
            },
            columns: [
                {
                    title: '明细类',
                    dataIndex: 'proDetailType'
                },
                {
                    title: '物料名称',
                    dataIndex: 'proContent',
                    render: text => <span style={{whiteSpace: 'prewrap'}}>{text}</span>
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '生产公司',
                    dataIndex: 'proCompany'
                },
                {
                    title: '确认物料名称',
                    dataIndex: 'erpData.ITEM_DESC'
                },
                {
                    title: '确认物料编码',
                    dataIndex: 'erpData.ITEM_NUM'
                },
                {
                    title: '是否能生产',
                    dataIndex: 'erpData.PROD_FLAG'
                },
                {
                    title: '工程师联系电话',
                    dataIndex: 'erpData.ENGINEER_PHONE'
                },
                {
                    title: '确认人电话',
                    dataIndex: 'erpData.ATTRIBUTE4'
                },
                {
                    title: '确认牌价',
                    dataIndex: 'erpData.PRICE'
                }
            ],
            rows: rows1
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div>
                    {/*<p style={{paddingLeft: '20px', color: 'red'}}><Icon type="exclamation-circle-o"/>选择环保属性后，需等环保工程师【郑磊18358773190】评审通过后，对应的生产公司才能查询到定制订单</p>*/}
                    <p style={{paddingLeft: '20px', color: 'red', fontSize: '25px'}}><Icon
                        style={{fontSize: 20}} type="info-circle"/>经公司研究决定，2024年5月31号起关闭DMC定制申请功能。如有定制需求，请联系我司销售人员，详情请查阅公告。
                    </p>
                </div>
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, left: 0}}
                            onClick={this.goView.bind(this, '/companyLink')}>生产公司联系方式</Button>
                    {/*<Button style={{position: 'absolute', bottom: 8, left: 0}}*/}
                    {/*        onClick={this.goView.bind(this, '/customOrder/add')}>创建</Button>*/}
                </div>
                <TableView {...tableViewProps}/>
            </div>

            <Modal
                visible={visible}
                maskClosable={false}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width={1200}
                closable={false}
            >
                <div className="dms-table-box">
                    <TableView {...tableDetailViewProps}/>
                </div>
            </Modal>

        </div>
    }
}

export default withRouter(CustomeOrderList);


// WEBPACK FOOTER //
// ./src/routes/customOrder/list.js